<template>
  <div
    class="inline-flex shrink-0 rounded-lg border border-gray-200 bg-gray-50 p-0.5"
    role="group"
    aria-label="Wersja językowa"
  >
    <button
      v-for="locale in locales"
      :key="locale"
      type="button"
      :class="tabClass(locale)"
      @click="$emit('update:modelValue', locale)"
    >
      {{ locale.toUpperCase() }}
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  locales: {
    type: Array,
    default: () => ['pl', 'en'],
  },
});

defineEmits(['update:modelValue']);

function tabClass(localeCode) {
  return [
    'inline-flex h-8 min-w-[2.75rem] items-center justify-center rounded-md px-3 text-sm font-medium transition-colors',
    localeCode === props.modelValue
      ? 'bg-green-50 text-green-700 shadow-sm ring-1 ring-inset ring-green-200'
      : 'text-gray-500 hover:text-gray-700',
  ];
}
</script>
